import React,{useState,useEffect} from 'react';
import Axios from 'axios';
import LoaderCircle from '../ui-elements/LoaderCircle';

const EditComment=({webToken,commentId,commentText,commentFunc,modalFunc,pageType})=>{
    const [commentData,setCommentData]=useState({cmntText:commentText});
    const [isSubmitDisabled, setIsSubmitDisabled]=useState(true);
    const [isSubmitted,setIsSubmitted]=useState(false);

    const checkAllValidFields=()=>{
        if(commentData.cmntText!==""&&commentData.cmntText.length>10&&commentData.cmntText!==commentText)
        {
            setIsSubmitDisabled(false);
        }
        else
        {
            setIsSubmitDisabled(true);
        }
    }

    const doSubmit=()=>{
        event.preventDefault();
        setIsSubmitted(true);
        console.log('submitting...');
        if(pageType==="quran")
        {
            Axios.post(`${alimAPIBaseURI}rpc/update_quran_comment`, {cmnt_id:commentId, cmnt_text:commentData.cmntText, cmtime:new Date().valueOf().toString()},{headers: {"Content-Type": "application/json","Authorization":`bearer ${webToken}`}}).then((data)=>{
                console.log(data);
                commentFunc(commentData.cmntText);
                modalFunc(false);
            }).catch((error)=>{
                console.log(error);
                modalFunc(false);
            });
        }
        else if(pageType==="hadith")
        {
            Axios.post(`${alimAPIBaseURI}rpc/update_hadith_comment`, {cmnt_id:commentId, cmnt_text:commentData.cmntText, cmtime:new Date().valueOf().toString()},{headers: {"Content-Type": "application/json","Authorization":`bearer ${webToken}`}}).then((data)=>{
                console.log(data);
                commentFunc(commentData.cmntText);
                modalFunc(false);
            }).catch((error)=>{
                console.log(error);
                modalFunc(false);
            });
        }
        else if(pageType==="history")
        {
            Axios.post(`${alimAPIBaseURI}rpc/update_history_comment`, {cmnt_id:commentId, cmnt_text:commentData.cmntText, cmtime:new Date().valueOf().toString()},{headers: {"Content-Type": "application/json","Authorization":`bearer ${webToken}`}}).then((data)=>{
                console.log(data);
                commentFunc(commentData.cmntText);
                modalFunc(false);
            }).catch((error)=>{
                console.log(error);
            });
        }
    }

    useEffect(()=>{
        checkAllValidFields();
    },[commentData])

    return(
        <>
            <form className='grid grid-cols-3 gap-3' method='post'>
                <div className="col-span-3 relative">
                    <label htmlFor="note-content" className="text-white/[.75] bg-deep-blue px-1 absolute -top-0.5 left-3 text-sm font-thin">
                        Your comment
                    </label>
                    <textarea required id="note-content" type="text" name="note-content" placeholder="Enter comment" className={`h-14 mt-2 bg-light-blue/10 dark:bg-light-blue w-full flex border border-light-blue dark:border-dark-grey-input py-1.5 px-3 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 alim-input-text-color-style rounded h-64 resize-none`} defaultValue={commentData.cmntText} onChange={(e)=>{setCommentData({...commentData,cmntText:e.target.value});}} minLength="8"/>
                </div>
                <div className={`col-span-1 flex flex-col justify-between pt-4 gap-4 relative`}>
                    {
                        isSubmitted?
                        <LoaderCircle/>
                        :
                        <input type='submit' className={`w-full py-3 bg-deep-red rounded text-white ${isSubmitDisabled?`opacity-50`:"red-button-hover-style cursor-pointer"}`} disabled={isSubmitDisabled} onClick={()=>{doSubmit()}} value={"Save changes"}/>
                    }
                </div>
            </form>
        </>
        
    )
}

export default EditComment;